export const SEND_INVITE = 'app/Invite/SEND_INVITE';
export const INVITE_FAILURE = 'app/Invite/INVITE_FAILURE';
export const INVITE_SUCCESS = 'app/Invite/INVITE_SUCCESS';
export const GET_INVITE_LINK = 'app/Invite/GET_INVITE_LINK';
export const GET_INVITE_LINK_SUCCESS = 'app/Invite/GET_INVITE_LINK_SUCCESS';
export const GET_INVITE_LINK_FAILURE = 'app/Invite/GET_INVITE_LINK_FAILURE';
